import React from "react";

export default function PostItClue({ onClose }) {
  return (
    <div className="flex items-center justify-center py-12 px-6 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 min-h-[60vh]">
      <div className="max-w-md">
        <div
          className="relative p-8 bg-gradient-to-br from-yellow-200 to-yellow-300 rounded-lg shadow-2xl transform rotate-2"
          style={{ boxShadow: "0 10px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(0,0,0,0.1)" }}
        >
          {/* Ruban adhésif */}
          <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-16 h-6 bg-yellow-100/40 rounded" />

          <div className="space-y-4">
            <div className="text-lg font-bold text-slate-800 border-b-2 border-slate-400 pb-2">
              📋 NOTE — Terminal audit
            </div>

            <div className="text-sm text-slate-800 leading-relaxed font-handwriting space-y-3">
              <p>
                La commande pour lancer <span className="font-mono font-bold">ingratitude.exe</span> se trouve
                dans la <span className="font-bold">salle des archives</span>.
              </p>
              <div className="bg-yellow-100/60 rounded p-2 font-mono text-xs text-slate-700 leading-relaxed">
                ARCHIVES_OLD / 2021 / UNSORTED<br />
                → dossier <span className="font-bold">MIRAGIO</span><br />
                → dossier <span className="font-bold">.ingratitude</span><br />
                → fichier <span className="font-bold">PROTOCOL.txt</span>
              </div>
              <p className="text-xs text-slate-600 italic">
                ⚠️ Le dossier MIRAGIO est verrouillé.<br />
                Le joueur des archives doit l'avoir ouvert pour y accéder.
              </p>
            </div>

            <div className="text-xs text-slate-600 italic mt-4">— Note interne</div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full px-4 py-3 rounded-lg bg-slate-700 hover:bg-slate-600 text-white font-semibold transition"
        >
          Fermer
        </button>

        <style jsx>{`
          .font-handwriting {
            font-family: 'Segoe Print', 'Bradley Hand', 'Brush Script MT', cursive;
          }
        `}</style>
      </div>
    </div>
  );
}